import { render, staticRenderFns } from "./LockerUsersDropdown.vue?vue&type=template&id=42036f65&"
import script from "./LockerUsersDropdown.vue?vue&type=script&lang=js&"
export * from "./LockerUsersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports